import { styled, RadioGroup } from '@mui/material';

export const RadioGroupStyled = styled(RadioGroup)(({ theme }) => ({
  '& .MuiFormControlLabel-root': {
    marginBottom: 0,
    paddingBottom: 0,
  },
}));
